// @flow
import * as React from 'react';
import AutocompleteSimpleInput from 'components/AutocompleteSimpleInput';
import Field from './Field';

const InputField = ({
  name,
  label,
  options,
  shouldRenderSuggestions
}: {
  name: string,
  label?: string,
  options: Array<string>,
  shouldRenderSuggestions?: Function
}) => (
  <Field
    name={name}
    label={label}
    renderInput={({
      value,
      id,
      qaId,
      hasError,
      updateValue,
      onBlur,
      onFocus
    }) => (
      <AutocompleteSimpleInput
        id={id}
        name={name}
        value={value || ''}
        options={options}
        shouldRenderSuggestions={shouldRenderSuggestions}
        hasError={hasError}
        data-qa-id={qaId}
        onChange={e => updateValue(e.target.value)}
        onBlur={onBlur}
        onFocus={onFocus}
      />
    )}
  />
);

export default InputField;
